import { render, staticRenderFns } from "./UserInfoDropDown.vue?vue&type=template&id=680dbd61&scoped=true&"
import script from "./UserInfoDropDown.vue?vue&type=script&lang=js&"
export * from "./UserInfoDropDown.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoDropDown.vue?vue&type=style&index=0&id=680dbd61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680dbd61",
  null
  
)

export default component.exports